import React from 'react'
import Assignments from './Assignments/Assignments'
import Essays from './Essays/Essays'
import Overview from './Overview/Overview'
import s from './ExpandedGrid.module.scss'

const ExpandedGrid = ({
	row,
	onOpenApplication,
	onAssignAssignment,
	onGenerateLor,
	onOpenEssay,
}) => {
	return (
		<div className={s.wrap}>
			<div className={s.grid}>
				<div className={s.col}>
					<Assignments row={row} />
				</div>
				<div className={s.col}>
					<Essays row={row} onOpenEssay={onOpenEssay} />
				</div>
				<div className={s.col}>
					<Overview row={row} onGenerateLor={onGenerateLor} />
				</div>
			</div>

			<div className={s.footer}>
				<button
					type="button"
					className={s.btnPrimary}
					onClick={e => {
						e.stopPropagation()
						onOpenApplication?.(row)
					}}
				>
					Open Application
				</button>
				<button
					type="button"
					className={s.btnSecondary}
					onClick={e => {
						e.stopPropagation()
						onAssignAssignment?.(row)
					}}
				>
					Assign Assignment
				</button>
			</div>
		</div>
	)
}

export default ExpandedGrid
